"use client";

import Link from "next/link";
import { type ColumnDef } from "@tanstack/react-table";
import { DataTable } from "@/components/data-table";

type Row = {
  id: string;
  evidenceCode: string;
  domain: string;
  score: string;
  captured: string;
  caseCode: string;
};

const columns: ColumnDef<Row>[] = [
  {
    accessorKey: "evidenceCode",
    header: "ID",
    cell: ({ row }) => (
      <Link href={`/evidence/${row.original.id}`} className="font-mono text-[var(--accent)]">
        {row.original.evidenceCode}
      </Link>
    ),
  },
  { accessorKey: "domain", header: "Suspect" },
  { accessorKey: "score", header: "Match" },
  { accessorKey: "captured", header: "Captured" },
  { accessorKey: "caseCode", header: "Case" },
];

export function EvidenceTable({ rows }: { rows: Row[] }) {
  return <DataTable data={rows} columns={columns} />;
}
